// Shared columns for Project Qualification Step Details & Create

export const PQS_PICKLIST_LABELS = {
  STATUS: "Project_Qualification_Step_Status__c",
  FUNNEL: "Funnel__c",
};

export function buildInfoFieldsForPqs({
  isEditing = false,
  form = null,
  data = null,
} = {}) {
  return [
    { label: "Name", path: "info.name", type: "text", readOnly: true },
    {
      label: "Passing Score",
      path: "info.passingScore",
      type: "number",
      readOnly: true,
    },
    {
      label: "Status",
      path: "info.status",
      type: "select",
      picklistLabel: PQS_PICKLIST_LABELS.STATUS,
    },
    {
      label: "Funnel",
      path: "info.funnel",
      type: "select",
      picklistLabel: PQS_PICKLIST_LABELS.FUNNEL,
    },
    { label: "Step Number", path: "info.stepNumber", type: "number" },
    {
      label: "Number of Attempts",
      path: "info.numberOfAttempts",
      type: "number",
    },
    {
      label: "Estimated Time (mins)",
      path: "info.estimatedTimeMinutes",
      type: "number",
      readOnly: true,
    },
    ...buildLookupFieldsForPqs({
      isEditing,
      form,
      data,
    }),
  ];
}

export function buildLookupFieldsForPqs({
  isEditing = false,
  form = null,
  data = null,
} = {}) {
  return [
    // Project lookup field
    {
      label: "Project",
      path: "info.projectId",
      type: "lookup",
      lookupObject: "Project",
      value: (form || data)?.info?.projectName || "—",
      linkTo:
        !isEditing && (form || data)?.info?.projectId
          ? `/p/${(form || data)?.info?.projectId}`
          : undefined,
      valueLabel: (form || data)?.info?.projectName || "—",
    },
    // Project Objective lookup field
    {
      label: "Project Objective",
      path: "info.projectObjectiveId",
      type: "lookup",
      lookupObject: "ProjectObjective",
      value: (data || form)?.info?.projectObjectiveName || "—",
      linkTo:
        !isEditing && (data || form)?.info?.projectObjectiveId
          ? `/po/${(data || form)?.info?.projectObjectiveId}`
          : undefined,
      valueLabel:
        (data || form)?.info?.projectObjectiveName ||
        (data || form)?.info?.projectObjectiveId ||
        "—",
    },
    // Qualification Step lookup field
    {
      label: "Qualification Step",
      path: "info.qualificationStepId",
      type: "lookup",
      lookupObject: "QualificationStep",
      value: (form || data)?.info?.qualificationStepName || "—",
      linkTo: undefined, // No link for Qualification Step (not a navigable entity)
      valueLabel: (form || data)?.info?.qualificationStepName || "—",
    },
  ];
}

export function buildSysFieldsForPqs() {
  return [
    {
      label: "CreatedById",
      path: "sys.createdById",
      type: "text",
      readOnly: true,
    },
    {
      label: "LastModifiedById",
      path: "sys.lastModifiedById",
      type: "text",
      readOnly: true,
    },
  ];
}

// Create modal
export function buildCreateFieldsForPqs() {
  return [
    {
      cols: 2,
      fields: [
        {
          label: "Project",
          path: "project",
          type: "searchable",
          required: true,
          info: "Search and select project",
          searchType: "project",
        },
        {
          label: "Project Objective",
          path: "objective",
          type: "searchable",
          info: "Search and select project objective",
          searchType: "projectObjective",
        },
      ],
    },
    {
      cols: 2,
      fields: [
        {
          label: "Status",
          path: "status",
          type: "select",
          required: true,
          picklistLabel: PQS_PICKLIST_LABELS.STATUS,
        },
        {
          label: "Qualification Step",
          path: "qualificationStep",
          type: "searchable",
          required: true,
          info: "Search and select qualification step",
          searchType: "qualificationStep",
        },
      ],
    },
    {
      cols: 2,
      fields: [
        {
          label: "Funnel",
          path: "funnel",
          type: "select",
          required: true,
          picklistLabel: PQS_PICKLIST_LABELS.FUNNEL,
        },
        {
          label: "Step Number",
          path: "stepNumber",
          type: "number",
          required: true,
          info: "Order of this qualification step",
        },
      ],
    },
    {
      label: "Number of Attempts",
      path: "numberOfAttempts",
      type: "number",
      required: true,
      info: "Max attempts allowed",
    },
  ];
}
